// Enquiry form sheet link: https://docs.google.com/spreadsheets/d/1n5g89GHU4GBekuENV7Zo9MS1_sHc1UHV0Pt6zil4M9Q/edit?usp=sharing
(function () {
  function lockPageScroll() {
    const html = document.documentElement;
    const body = document.body;
    if (body.getAttribute('data-enquire-scroll-lock') === 'true') return;

    const scrollY = window.scrollY;
    const gap = window.innerWidth - html.clientWidth;

    body.setAttribute('data-enquire-scroll-lock', 'true');
    body.setAttribute('data-enquire-scroll-y', String(scrollY));
    body.setAttribute('data-enquire-pad', body.style.paddingRight);
    body.setAttribute('data-enquire-overflow', body.style.overflow);
    html.setAttribute('data-enquire-overflow', html.style.overflow);
    html.setAttribute('data-enquire-overscroll', html.style.overscrollBehavior);

    html.style.overflow = 'hidden';
    html.style.overscrollBehavior = 'none';
    body.style.overflow = 'hidden';
    if (gap > 0) body.style.paddingRight = gap + 'px';
    body.style.position = 'fixed';
    body.style.top = '-' + scrollY + 'px';
    body.style.left = '0';
    body.style.right = '0';
    body.style.width = '100%';
  }

  function unlockPageScroll() {
    const html = document.documentElement;
    const body = document.body;
    if (body.getAttribute('data-enquire-scroll-lock') !== 'true') return;

    const scrollY = parseInt(body.getAttribute('data-enquire-scroll-y') || '0', 10);
    const prevPad = body.getAttribute('data-enquire-pad') || '';
    const prevBodyOverflow = body.getAttribute('data-enquire-overflow') || '';
    const prevHtmlOverflow = html.getAttribute('data-enquire-overflow') || '';
    const prevOverscroll = html.getAttribute('data-enquire-overscroll') || '';

    html.style.overflow = prevHtmlOverflow;
    html.style.overscrollBehavior = prevOverscroll;
    body.style.overflow = prevBodyOverflow;
    body.style.paddingRight = prevPad;
    body.style.position = '';
    body.style.top = '';
    body.style.left = '';
    body.style.right = '';
    body.style.width = '';
    body.removeAttribute('data-enquire-scroll-lock');
    body.removeAttribute('data-enquire-scroll-y');
    body.removeAttribute('data-enquire-pad');
    body.removeAttribute('data-enquire-overflow');
    html.removeAttribute('data-enquire-overflow');
    html.removeAttribute('data-enquire-overscroll');

    window.scrollTo(0, scrollY);
  }

  function initEnquireNow(root) {
    const box = root.querySelector('.enquire-now');
    const form = root.querySelector('.enquire-now__form');
    const btn = root.querySelector('.enquire-now__submit');
    const labelEl = btn ? btn.querySelector('.enquire-now__submit-label') : null;
    const dialog = box ? box.querySelector('.enquire-now__dialog') : null;
    const closeBtn = box ? box.querySelector('.enquire-now__dialog-close') : null;
    if (!box || !form || !btn || !labelEl || !dialog) return;
    if (box.getAttribute('data-enquire-ready') === 'true') return;
    box.setAttribute('data-enquire-ready', 'true');

    form.addEventListener(
      'submit',
      function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
      },
      true
    );

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        if (typeof dialog.close === 'function') dialog.close();
      });
    }

    dialog.addEventListener('click', function (event) {
      if (event.target === dialog && typeof dialog.close === 'function') dialog.close();
    });

    dialog.addEventListener('close', function () {
      unlockPageScroll();
    });

    btn.addEventListener('click', function () {
      if (typeof form.reportValidity === 'function' && !form.reportValidity()) return;

      const webhook = box.getAttribute('data-sheets-url') || '';
      if (!webhook) return;

      const originalLabel = btn.getAttribute('data-label') || labelEl.textContent;
      btn.setAttribute('aria-busy', 'true');
      btn.disabled = true;
      btn.classList.add('enquire-now__submit--loading');

      const payload = new FormData();
      payload.append('name', form.elements.name ? form.elements.name.value : '');
      payload.append('company', form.elements.company ? form.elements.company.value : '');
      payload.append('email', form.elements.email ? form.elements.email.value : '');
      payload.append('requirement', form.elements.requirement ? form.elements.requirement.value : '');

      fetch(webhook, {
        method: 'POST',
        mode: 'no-cors',
        body: payload,
        keepalive: true
      })
        .catch(function () {})
        .then(function () {
          form.reset();
          btn.classList.remove('enquire-now__submit--loading');
          btn.classList.add('enquire-now__submit--submitted');
          labelEl.textContent = 'Submitted';
          btn.removeAttribute('aria-busy');

          function restoreButton() {
            labelEl.textContent = originalLabel;
            btn.classList.remove('enquire-now__submit--submitted');
            btn.disabled = false;
          }

          if (typeof dialog.showModal === 'function') {
            lockPageScroll();
            dialog.showModal();
            dialog.addEventListener(
              'close',
              function () {
                restoreButton();
              },
              { once: true }
            );
          } else {
            restoreButton();
          }
        });
    });
  }

  function initAll() {
    document.querySelectorAll('.section-homepage-enquire-now').forEach(initEnquireNow);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.classList && event.target.classList.contains('section-homepage-enquire-now')) {
      initEnquireNow(event.target);
    }
  });
})();
